import React, { Component } from 'react'
import logo from "../../assets/logo_espol_interno.svg";
import check from "../../assets/check.svg";
import checkGreen from "../../assets/check.png";
import equis from "../../assets/eliminar.svg"
import Modal from './Modal';
import axios from "axios";
import "../../css/FormRegistroContrasenia.css"
import ComponenteContrasenia from './ComponenteContrasenia';
import { Navigate } from 'react-router-dom';
import Header from '../components/Header.js'
import Footer from '../components/Footer.js'
import CenteredWrapper from '../components/CenteredWrapper.js';
import BotonExpandible from "../components/BotonExpandible";
import Acuerdo from './Acuerdo.js'
import anuncioico from "../../assets/AnuncioICO.svg";
import importante from "../../assets/importante.svg";
import cedimg_veri from "../../assets/validacion-exitosa.svg"
import alerta from "../../assets/alertacc.svg";


export class FormRegistroContrasenia extends Component {

    constructor(props) {
        super(props);

        this.state = {
            IsFirmadoElect: this.props.IsFirmadoElect,
            verAcuerdo: false,
            showPassword: false,
            showRepetirPassw: false,
            modalIsOpen: false,
            activebutton: true,
            datosUsuario: {
                id: this.props.id,
                nombres: this.props.nombres,
                apellidos: this.props.apellidos,
                identificacion: this.props.identificacion,
                alias_sugerido: this.props.alias_sugerido,
                usuarioEscogido: this.props.usuario_sugerido,
                correoAlterno: this.props.correoAlterno,
                rol: this.props.rol,
                telefono: this.props.telefono,
                unidad: this.props.unidad,
                idAcueFirmElec: this.props.idAcFirmaElec,
                tipoForm: this.props.tipoForm,
                rostro_base64: this.props.rostro_base64,
                cedula_base64: this.props.cedula_base64,
            },
            contra: {
                contrasena: "",
                contrasenaCumple: false,
                repetirContraCumple: false,
                terminos: ""
            },
            expresiones: {
                contrasena: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@*._-]{10,12}$/,
            },
            renderNavigateLogin: false,
            tokenNuevaCuenta: sessionStorage.getItem("token_nueva_cuenta"),
            modalMessage: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen: ""
            },
        };
        this.abrirModalInfo = this.abrirModalInfo.bind(this);
        this.cambiarEstado = this.cambiarEstado.bind(this);

        this.renderRegistro = this.renderRegistro.bind(this);

        this.activebuttonf = this.activebuttonf.bind(this);
        this.disabledbuttonf = this.disabledbuttonf.bind(this);
    }

    componentWillMount() {
        this.agregarNombresEnRegla();
    }

    abrirModalMessage = () => {
        this.setState({
            modalMessage: {
                ...this.state.modalMessage,
                show: true
            }
        });
    }

    cerrarModalMessage = () => {
        this.setState({
            modalMessage: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
    }


    agregarNombresEnRegla() {
        var nombreString = "";
        var nombres = this.state.datosUsuario.nombres.split(" ");
        // var nombres_temp = nombres.split(" ");
        var apellidos = this.state.datosUsuario.apellidos.split(" ");
        // var apellidos_temp = apellidos.split(" ");

        var nombreCompleto = nombres.concat(apellidos);

        for (var i = 0; i < nombreCompleto.length; i++) {
            if (i == nombreCompleto.length - 1) {
                nombreString = nombreString.concat(nombreCompleto[i]);
            } else {
                nombreString = nombreString.concat(nombreCompleto[i] + ", ");
            }
        }
        this.setState({
            nombresRegla: nombreString
        })
    }

    activebuttonf() {
        this.setState({ activebutton: true });
    }

    disabledbuttonf() {
        this.setState({ activebutton: false });

    }

    abrirModalInfo() {
        this.setState({ modalIsOpen: true },()=>{
            this.activebuttonf();
        });
    }

    cerrarModalInfoAcuerdo = () => {

        this.setState({ modalIsOpen: false }, () => {
            this.abrirAcuerdo();
        });
    }
    cerrarModalInfoInicio = () => {
        this.setState({
            modalIsOpen: false,
            renderNavigateLogin: true
        });
    }

    abrirModalFirmadoAcuerdo = () => {
        this.setState({ modalFirmadoAcuerdo: true });
    }
    cerrarModalFirmadoAcuerdo = () => {
        this.setState({ modalIsOpen: false, modalFirmadoAcuerdo: false });
    }



    abrirAcuerdo = () => {
        this.setState({ verAcuerdo: true });
    }

    cerrarAcuerdo = () => {
        this.setState({ verAcuerdo: false });
    }

    handlerDatosFormRegistro = async (e) => {
        await this.setState({
            contra: {
                ...this.state.contra,
                [e.target.name]: e.target.value,
                terminos: e.target.checked
            }
        })
    }

    cambiarEstado(contrasenaactual, valor, contraCumple, repetirContraCumple) {
        this.setState({
            contra: {
                ...this.state.contra,
                contrasena: valor,
                contrasenaCumple: contraCumple,
                repetirContraCumple: repetirContraCumple
            }
        })
    }

    renderRegistro(e) {
        e.preventDefault();
        this.props.renderFormRegistro(false);
    }



    postCrearCuentaElectronica = async (e) => {
        this.props.callTagManager("click-btn-crear-cuenta");
        e.preventDefault();
        this.disabledbuttonf();

        var crearCuenta = {
            alias: this.state.datosUsuario.alias_sugerido,
            username: this.state.datosUsuario.usuarioEscogido,
            nombres: this.state.datosUsuario.nombres,
            apellidos: this.state.datosUsuario.apellidos,
            identificacion: this.state.datosUsuario.identificacion,
            personaId: this.state.datosUsuario.id,
            password: this.state.contra.contrasena,
            correoAlterno: this.state.datosUsuario.correoAlterno,
            rol: this.state.datosUsuario.rol,
            telefono: this.state.datosUsuario.telefono,
            unidad: this.state.datosUsuario.unidad,
            isActive: true,
            idDocFirmadoElectronicamente: this.state.datosUsuario.idAcueFirmElec
        }
        /*if( this.state.datosUsuario.tipoForm == "A"){
            crearCuenta.isacuerddig=false;  
        }*/
        //DENTRO DE API/CUENTAUSUARIO DEBO GUARDAR EL REGISTRO EN LA TABLA T_ACUERDO_MEDELECT_DATPERS PARA USUARIOS DE BASE QUE CREAN CUENTA. (FIRMA MANUAL O ELECTRÓNICA)
        axios.post(`${process.env.REACT_APP_API}api/CuentaUsuario`, crearCuenta, {
            headers: {
                Authorization: `Bearer ${this.state.tokenNuevaCuenta}`
            }
        })
            .then(resp => {
                if (resp.status === 200) {
                    /*CREAR LA SOLICITUD SI SE CREA LA CUENTA SOLO PARA TIPOFORM="A"*/
                    if (this.state.datosUsuario.tipoForm == "A") {
                        var datoscuenta = {
                            identificacion: this.state.datosUsuario.identificacion,
                            nombres: this.state.datosUsuario.nombres,
                            apellidos: this.state.datosUsuario.apellidos,
                            telefono: this.state.datosUsuario.telefono,
                            actividad: this.state.datosUsuario.rol,
                            unidad: this.state.datosUsuario.unidad,
                            correo: this.state.datosUsuario.correoAlterno,
                            usuario_sugerido: this.state.datosUsuario.usuarioEscogido,
                            alias_sugerido: this.state.datosUsuario.alias_sugerido,
                            idAcueFirmElec: this.state.datosUsuario.idAcueFirmElec,
                        }
                        //guardar el registro en la tabla IDACUERDOMEDELECTDATPERS
                        var DataJson = JSON.stringify(datoscuenta);
                        var motivo_temp = "Solicitud a espera de revisión";
                        var estado_temp = "No Revisado CC";
                        if (!this.props.necesitaRevision) {
                            motivo_temp = "Solicitud CC aceptada de manera automatica por el sistema.";
                            estado_temp = "Aceptado CC";
                        }
                        var solicitud = {
                            estado: estado_temp,
                            identificacion: this.state.datosUsuario.identificacion,
                            infoSolicitud: DataJson,
                            Motivo: motivo_temp,
                            fotoimgRostro: this.state.datosUsuario.rostro_base64,
                            fotoimgCedula: this.state.datosUsuario.cedula_base64,
                            filePdf: this.state.pdfData,
                            tipoAcuerdo: "D",//antes era M de manual, pero ahora viene a ser D de Digital.
                            isCedulaEqualRostro:!this.props.necesitaRevision
                        }

                        sessionStorage.setItem("token_nueva_cuenta", resp.data.token);

                        if (!this.state.IsFirmadoElect) {
                            axios.post(`${process.env.REACT_APP_API}api/Solicitud`, solicitud, {
                                headers: {
                                    Authorization: `Bearer ${this.state.tokenNuevaCuenta}`
                                }
                            })
                                .then(resp => {
                                    this.abrirModalInfo();
                                }).catch(error => {
                                    this.activebuttonf();
                                    if (error.response && error.response.status === 401) {
                                        this.setState({
                                            modalMessage: {
                                                titulo: "Error con validación del token",
                                                mensaje: "El token del usuario ha expirado. Por favor comience el proceso nuevamente.",
                                                imagen: equis,
                                                show: true
                                            }
                                        });
                                    } else if (error.response.data.errorMessage = "Captcha invalido.") {
                                        this.setState({
                                            modalMessage: {
                                                titulo: "Error con validación del captcha",
                                                mensaje: error.response.data.errorMessage,
                                                imagen: equis,
                                                show: true
                                            }
                                        });
                                    } else {
                                        this.setState({
                                            modalMessage: {
                                                titulo: "Error en el envio de solicitud",
                                                mensaje: "Exisito un problema al enviar la solicitud",
                                                imagen: equis,
                                                show: true
                                            }
                                        });

                                    }
                                })
                        } else {
                            this.abrirModalInfo();
                        }
                    }
                }
                this.activebuttonf();
            }).catch(error => {
                if (error.response && error.response.status === 401) {

                    this.setState({
                        modalMessage: {
                            titulo: "Error con validación del token",
                            mensaje: "El token del usuario ha expirado. Por favor comience el proceso nuevamente.",
                            imagen: equis,
                            show: true
                        }
                    });
                } else if (error.response && error.response.status === 500) {
                    const mensaje = error.response.data?.errorMessage;
                    this.setState({
                        modalMessage: {
                            show: true,
                            titulo: "Error en la solicitud",
                            mensaje: mensaje || "Ocurrió un error en el servidor.",
                            imagen: equis,
                        }
                    });
                } else {
                    this.setState({
                        modalMessage: {
                            show: true,
                            titulo: "Error en el envío de solicitud",
                            mensaje: "Existió un problema al enviar la solicitud.",
                            imagen: equis,
                        }
                    });
                }
                this.activebuttonf();
            })
    }


    render() {
        const fechaLimite = (() => {
            const fecha = new Date();
            fecha.setDate(fecha.getMonth() + 1);
            const dia = String(fecha.getDate()).padStart(2, '0');
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const anio = fecha.getFullYear();
            return `${dia}/${mes}/${anio}`;
        })();
        return (
            this.state.renderNavigateLogin ? <Navigate to="/inicio" /> :
                (this.state.verAcuerdo ?
                    <Acuerdo
                        identificacion={this.state.datosUsuario.identificacion}
                        nombres={this.state.datosUsuario.nombres}
                        apellidos={this.state.datosUsuario.apellidos}
                        alias_sugerido={this.state.datosUsuario.alias_sugerido}
                        usuario_sugerido={this.state.datosUsuario.usuarioEscogido}
                        correoAlterno={this.state.datosUsuario.correoAlterno}
                        rol={this.state.datosUsuario.rol}
                        telefono={this.state.datosUsuario.telefono}
                        unidad={this.state.datosUsuario.unidad}
                        tipoForm={"CC"}
                        mensaje_titulo="CREAR CUENTA"
                        verbtngeneral={false}
                        verbtngeneralElectronica={true}
                        callTagManager={this.props.callTagManager}
                        /* useEffect={this.props.useEffect}*/
                        showHeader={false}
                        tipo_token={"propio"}
                    />
                    :
                    (<div>
                        <CenteredWrapper>
                            <div className="registroContra-container">
                                <form>
                                    <div className="row">
                                        <BotonExpandible
                                            mensaje={
                                                <div className=" col-xl-12 ">
                                                    <p className="text-justify-center">
                                                        <b>REGLAS QUE DEBE CUMPLIR LA CONTRASEÑA:</b>
                                                    </p>
                                                    <ul>
                                                        <li>Tener mínimo 10 caracteres y máximo 12.</li>
                                                        <li>Tener al menos una letra minúscula.</li>
                                                        <li>Tener al menos una letra mayúscula.</li>
                                                        <li>Tener al menos un número.</li>
                                                        <li>Solo permite lo siguientes caracteres especiales: @ , * , . , _ , - </li>
                                                        <li>La contraseña no puede ser similar al usuario: {this.state.datosUsuario.usuarioEscogido}. </li>
                                                        <li>La contraseña no puede contener las siguientes palabras: {this.state.nombresRegla}.</li>

                                                    </ul>
                                                </div>
                                            }
                                        />
                                    </div>
                                    <br />
                                    <div className="row-datos-usuario">
                                        {/* <div className="col-12 col-md-2 col-lg-2 col-xl-2">

                                    </div> */}
                                        <div className="">
                                            <label id="registroContra-textoLabel">Usuario: </label>
                                            <input className="form-control" type="text" name="usuarioEscogido" defaultValue={this.state.datosUsuario.usuarioEscogido} disabled />
                                        </div>
                                        {/* <div className="col-12 col-md-1 col-lg-2 col-xl-2">

                                    </div> */}
                                        <div className="">
                                            <label id="registroContra-textoLabel">Alias sugerido: </label>
                                            <label className="sr-only" htmlFor="inlineFormInputGroupUsername"></label>
                                            <div className="input-group">
                                                <input type="text" className="form-control" id="inlineFormInputGroupUsername" name="alias_sugerido" defaultValue={this.state.datosUsuario.alias_sugerido} disabled />
                                                <div id="registroContra-textoLabel" className="input-group-text">@espol.edu.ec</div>
                                            </div>
                                        </div>
                                        {/* <div className="col-12  col-xl-2">

                                    </div> */}
                                    </div>
                                    <br />

                                    <div className="row">
                                        <div className="col-md-2">
                                        </div>
                                        <div className="col-md-8">
                                            <ComponenteContrasenia
                                                cambiarEstado={this.cambiarEstado}
                                                columnas="col-md-8 col-xl-6"
                                                expresionRegular={this.state.expresiones.contrasena}
                                                nombres={this.state.datosUsuario.nombres}
                                                apellidos={this.state.datosUsuario.apellidos}
                                                usuario={this.state.datosUsuario.usuarioEscogido}
                                                isUpdateePss={false}
                                            >
                                            </ComponenteContrasenia>
                                        </div>
                                        <div className="col-md-2">
                                        </div>

                                    </div>
                                    <br />
                                    <div className="registroContra-container-botonGuardar">
                                        <button
                                            type="submit"
                                            disabled={this.state.contra.contrasena &&
                                                this.state.contra.contrasenaCumple &&
                                                this.state.contra.repetirContraCumple && this.state.activebutton ? false : true}
                                            className={this.state.contra.contrasena &&
                                                this.state.contra.contrasenaCumple &&
                                                this.state.contra.repetirContraCumple && this.state.activebutton ?
                                                "registroContra-btn-submit" : "registroContra-btn-submit-disabled"}
                                            onClick={this.postCrearCuentaElectronica}>GUARDAR
                                        </button>

                                        {!this.state.activebutton ?
                                            <span className="registroContra-fr-top spinner-border text-primary ms-2" role="status" aria-hidden="true"></span>
                                            : null}

                                    </div>
                                </form>
                            </div>
                        </CenteredWrapper>
                        <Footer />

                        {this.state.modalIsOpen &&
                            <Modal
                                isOpen={this.state.modalIsOpen}
                                cerrarModal={this.cerrarModalInfo}
                                verBoton={false}
                                srcImagen={cedimg_veri}
                                claseHeader={"identificador_exito"}
                            >
                                <div className="row modal_nuevo">
                                    <div className="paso-icono">
                                        <div className="contenedor-mensaje-modal">
                                            {this.props.necesitaRevision ? (
                                                <p className="text-center">
                                                    <strong> Cuenta y solicitud creadas exitosamente</strong>
                                                </p>
                                            ) : (
                                                <p className="text-center">
                                                    <strong>Cuenta creada exitosamente</strong>
                                                </p>
                                            )}
                                            {!this.props.necesitaRevision &&
                                                <div className="contenedor-interno-mensaje-modal">
                                                    <img className="icon-text" src={alerta} alt="alerta"></img>
                                                    <div className="mensaje-modal">
                                                        <p className='mensaje-informativo'>Para completar el proceso de creación, <strong>deberá firmar hasta el {fechaLimite} </strong>el acuerdo de uso de datos personales y medios electrónicos.</p>
                                                    </div>
                                                </div>
                                            }

                                            <p className='text-center'>Deberá estar atento a su correo electrónico alterno para conocer el estado de su solicitud y recibir, de ser necesario, las indicaciones para rectificar sus documentos.</p>

                                            {/* this.props.necesitaRevision &&
                                            <p className='mensaje-informativo'>Para completar el proceso de creación, <strong>deberá firmar hasta el {fechaLimite} </strong>el acuerdo de uso de datos personales y medios electrónicos.</p>

                                        */}

                                            {this.props.necesitaRevision ?
                                                <button className='modal-btn-submit' onClick={this.cerrarModalInfoInicio}>Cerrar</button>
                                                :
                                                <button className='modal-btn-submit' onClick={this.cerrarModalInfoAcuerdo}>Ir a firmar el acuerdo</button>
                                            }
                                            {/*<p className='text-center'>Le comunicamos que luego de 1 hora su cuenta electrónica se encontrará lista para ser utilizada. Una vez culminado el tiempo, usted podrá acceder a beneficios como uso de la plataforma Office365, correo electrónico, acceso a la red inalámbrica.</p>
                                        {<p className='text-center'>El siguiente enlace le permitirá hacer uso de su correo electrónico cuando culmine el tiempo de espera:
                                            <a
                                                href="https://sts.espol.edu.ec/adfs/ls/?cbcxt=&popupui=&vv=&username=&mkt=&lc=&wfresh=&wa=wsignin1.0&wtrealm=urn:federation:MicrosoftOnline&wctx=bk%3D1387224687%26LoginOptions%3D3"
                                                className='registroContra-vinculo'
                                                target="_blank"
                                                rel="noopener noreferrer">clic aquí</a>
                                        </p>*/}
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        }

                        {this.state.modalFirmadoAcuerdo &&
                            <Modal isOpen={this.state.verModalFirmadoAcuerdo} cerrarModal={this.cerrarModalFirmadoAcuerdo} verBoton={true} textoBoton="ACEPTAR" >
                                <p className='text-center'><strong>Es obligatorio que firme el acuerdo de Datos Personales y Medios Electrónicos</strong></p>
                                <div align="center" className='mt-6 mb-6'>
                                    <img className="registroContra-check" src={checkGreen} alt="Exitoso"></img>
                                </div>
                                <p className='text-center'>Para completar el proceso de creación de su cuenta, <strong>deberá firmar</strong> el Acuerdo de Uso de Datos Personales y Medios Electrónicos. Si el acuerdo no es firmado hasta el 31/08/2026, <strong>su cuenta será bloqueada hasta que se complete este requisito.</strong></p>
                            </Modal>
                        }


                        {
                            this.state.modalMessage.show &&
                            <Modal isOpen={this.state.modalMessage.show} cerrarModal={this.cerrarModalMessage} verBoton={true} textoBoton="ACEPTAR" >
                                <p className='text-center'><strong>{this.state.modalMessage.titulo}</strong></p>
                                <div className='mt-6 mb-6' align="center">
                                    <img className="nacionalidad-check" src={this.state.modalMessage.imagen} alt="Exitoso"></img>
                                </div>
                                <p className='text-center'>{this.state.modalMessage.mensaje}</p>
                            </Modal>
                        }

                    </div>
                    )
                )
        )
    }
}

export default FormRegistroContrasenia
